import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef as a, useState as m } from "react";
import { getOwnerDocument as d } from '../utils/owner.js';
import { useDisposables as g } from './use-disposables.js';
import { useEvent as u } from './use-event.js';
function E(e) {
  var t = e.width / 2,
    n = e.height / 2;
  return {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function P(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function w() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$disabled = _ref.disabled,
    e = _ref$disabled === void 0 ? !1 : _ref$disabled;
  var t = a(null),
    _m = m(!1),
    _m2 = _slicedToArray(_m, 2),
    n = _m2[0],
    l = _m2[1],
    r = g(),
    o = u(function () {
      t.current = null, l(!1), r.dispose();
    }),
    f = u(function (s) {
      if (r.dispose(), t.current === null) {
        t.current = s.currentTarget, l(!0);
        {
          var i = d(s.currentTarget);
          r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", function (c) {
            if (t.current) {
              var p = E(c);
              l(P(p, t.current.getBoundingClientRect()));
            }
          }, !1), r.addEventListener(i, "pointercancel", o, !1);
        }
      }
    });
  return {
    pressed: n,
    pressProps: e ? {} : {
      onPointerDown: f,
      onPointerUp: o,
      onClick: o
    }
  };
}
export { w as useActivePress };